// Smooth scrolling anchors
import $ from 'jquery';

$(() => {

    $('a').on('click', function(e){

		let isSmallMQ = window.matchMedia('(max-width: 575px)');

		let headerHeight = 0;

		if ( isSmallMQ.matches ){
			headerHeight = $('#js-header').height() + 40;
		}

        if( this.hash !== "" ){

            const hash = this.hash;

            if( $(hash).length == 0 ){
                window.location.href = hash;
            } else {

                e.preventDefault();

                $('html, body').animate({
                    scrollTop: $(hash).offset().top - headerHeight
                }, 800);
            }
        }
    });
});
